/** @jsxImportSource @emotion/react */
import React, { useEffect, useCallback, useState,useContext } from 'react';
// import { useTheme } from '@mui/material/styles';
// import withStyles from '@mui/styles/withStyles';
import { Grid, Typography, Tooltip, IconButton, Button, Snackbar, useMediaQuery, CircularProgress, DialogContent, useTheme, useEventCallback } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { useDropzone } from 'react-dropzone';
import MySnackbarContentWrapper from '../../Components/Snackbars';
// import addImage from "../../assets/images/add_image.svg";
// import deleteIcon from "../../assets/images/delete.svg";
// import Compressor from 'compressorjs';
import { Cropper } from 'react-cropper';
import "cropperjs/dist/cropper.css";
import axios from '../../Helper/Axios/interceptor';
// import useEventCallback from 'helpers/useEventCallBack';
// import imageCompression from 'browser-image-compression';
import { RotateLeft, RotateRight, ZoomIn, ZoomOut } from '@mui/icons-material';
import LivePhotoUpload from './LivePhotoUpload';
import config from '../../config';
import FullscreenLogoLoader from '../../Components/FullScreenLoader'
import { StyledTextField } from '../../Components/CustomTextfield';
import { Il8nContext } from '../../Helper/i18n';



const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        height: '70px',
        display: 'flex'
    },
    center: {
        // margin: 'auto',
        textAlign: 'center'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(2),
        marginTop: '5px',
        color: '#F54040',
        background: '#F4F4F4'
    },
    closeButtonResp: {
        color: '#F54040',
        background: '#F4F4F4'
    },
    button: {
        "&:hover": {
            background: "none"
        }
    },
    select: {
        "&:focus": {
            background: "none"
        }
    },
    deleteImageDiv: {
        width: '25px',
        height: '25px',
        background: '#000',
        opacity: 0.8,
        borderRadius: '50%',
        marginLeft: '42px',
        marginTop: '-70px'
    },
    deleteImage: {
        marginLeft: '6px',
        marginTop: '3px',
        width: '13px'
    },
    loader: {
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
});

const DialogTitle = /* withStyles(styles) */(props => {
    const { onClose, title, setRotate, rotate, zoom, setZoom, setSize, value } = props;
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));
    const classes = {
        root: {
            margin: 0,
            padding: theme.spacing(2),
            height: '70px',
            display: 'flex'
        },
        center: {
            // margin: 'auto',
            textAlign: 'center'
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(2),
            marginTop: '5px',
            color: '#F54040',
            background: '#F4F4F4'
        },
        closeButtonResp: {
            color: '#F54040',
            background: '#F4F4F4'
        },
        button: {
            "&:hover": {
                background: "none"
            }
        },
        select: {
            "&:focus": {
                background: "none"
            }
        },
        deleteImageDiv: {
            width: '25px',
            height: '25px',
            background: '#000',
            opacity: 0.8,
            borderRadius: '50%',
            marginLeft: '42px',
            marginTop: '-70px'
        },
        deleteImage: {
            marginLeft: '6px',
            marginTop: '3px',
            width: '13px'
        },
        loader: {
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    }
    return (
        <MuiDialogTitle className={classes.root}>
            <Grid container spacing={1}>
                <Grid item md={8} sm={12} xs={12} style={{ margin: "auto" }}>
                    <Typography variant="h5" style={matches ? {} : { marginLeft: '36px' }}>{title}
                        {matches &&
                            <IconButton
                                aria-label="close"
                                className={classes.closeButtonResp}
                                style={{ float: "right" }}
                                onClick={onClose}
                                size="large">
                                <CloseIcon />
                            </IconButton>} </Typography>
                </Grid>
                <Grid item md={4} sm={12} xs={12} className={classes.center}>
                    {/* <Tooltip title="Select Size" aria-label="select-size">
                        <Select
                            value={value}
                            classes={{root: classes.select}}
                            onChange={(e)=>{setSize(e)}}
                            inputProps={{name: 'size'}}
                        >
                            <MenuItem value={'400x400'}>400 x 400</MenuItem>
                            <MenuItem value={'400x300'}>400 x 300</MenuItem>
                            <MenuItem value={'300x400'}>300 x 400</MenuItem>
                            <MenuItem value={'400x200'}>400 x 200</MenuItem>
                        </Select>
                    </Tooltip> */}
                    <Tooltip title="Zoom In" aria-label="zoom-right">
                        <IconButton
                            aria-label="zoom"
                            onClick={() => setZoom(zoom < 0 ? 0.1 : zoom + 0.1)}
                            className={classes.button}
                            size="large">
                            <ZoomIn />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Zoom Out" aria-label="zoom-left">
                        <IconButton
                            aria-label="zoom"
                            onClick={() => setZoom(zoom > 0 ? -0.1 : zoom - 0.1)}
                            className={classes.button}
                            size="large">
                            <ZoomOut />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Rotate Right" aria-label="rotate-right">
                        <IconButton
                            aria-label="rotate"
                            onClick={() => setRotate(rotate + 90)}
                            className={classes.button}
                            size="large">
                            <RotateRight />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Rotate Left" aria-label="rotate-left">
                        <IconButton
                            aria-label="done"
                            onClick={() => setRotate(rotate - 90)}
                            className={classes.button}
                            size="large">
                            <RotateLeft />
                        </IconButton>
                    </Tooltip>
                    {!matches && <Tooltip title="Close" aria-label="close">
                        <IconButton
                            aria-label="close"
                            className={classes.closeButton}
                            onClick={onClose}
                            size="large">
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>}
                </Grid>
            </Grid>
        </MuiDialogTitle>
    );
});

var cropperInstance = null
const setCropperInstance = (ins) => {
    cropperInstance = ins
}
var canvasId = 0;
var screamId = 0;

function UploadDialog({ handleClose, onSave, image, count, imageArray, title, length, ...props }) {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));
    const [rotate, setRotate] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [imageWidth, setImageWidth] = useState(400)
    const [imageHeight, setImageHeight] = useState(400)
    const [value, setValue] = useState("400x400")
    const [imgArray, setImgArray] = useState([])
    const [imgIndex, setImgIndex] = useState(0)
    const [loader, setLoader] = useState(false)
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [aadharImg, setAadharImg] = useState({})
    const [openLivePhotoDialog, setOpenLivePhotoDialog] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const localeText = useContext(Il8nContext)

    const classes = {
        root: {
            margin: 0,
            padding: theme.spacing(2),
            height: '70px',
            display: 'flex'
        },
        center: {
            // margin: 'auto',
            textAlign: 'center'
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(2),
            marginTop: '5px',
            color: '#F54040',
            background: '#F4F4F4'
        },
        closeButtonResp: {
            color: '#F54040',
            background: '#F4F4F4'
        },
        button: {
            "&:hover": {
                background: "none"
            }
        },
        select: {
            "&:focus": {
                background: "none"
            }
        },
        deleteImageDiv: {
            width: '25px',
            height: '25px',
            background: '#000',
            opacity: 0.8,
            borderRadius: '50%',
            marginLeft: '42px',
            marginTop: '-70px'
        },
        deleteImage: {
            marginLeft: '6px',
            marginTop: '3px',
            width: '13px',
            backgroundColor: "blue"
        },
        loader: {
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    }

    const api = {
        maskAadhar: "/ms-diy-process/diy/OCRimage/encoded",
    }

    //const [{rotate,zoom, imageWidth, imageHeight, value,imgArray,imgIndex},]=useState({rotate:0,zoom:1,imageWidth: 400, imageHeight: 400, value: '400x400',imgArray:[],imgIndex:0});

    const _setEditorRef = React.useRef(null);
    const onDrop = useCallback((acceptedFiles, index) => {
        // setImgIndex(index)
        setLoader(true)
        let reader = new FileReader();
        let promise = new Promise((res, rej) => {
            reader.onload = (readBytes) => {
                var NimgArray = imgArray
                NimgArray.push(readBytes.currentTarget.result)
                setImgArray(NimgArray)
                var arr = [...NimgArray];
                var canvas = document.createElement("canvas")
                canvas.id = "canvas" + (canvasId++)
                canvas.style.display = "none"
                document.body.appendChild(canvas)
                var img = document.createElement("img")
                img.id = "scream" + (screamId++)
                img.style.display = "none"
                img.src = imgArray[imgIndex]
                document.body.appendChild(img)
                if (title?.toLowerCase().indexOf("aadhaar") > -1) {
                    loadcallback(readBytes.currentTarget.result.split("base64,")[1])
                }
                if (NimgArray.length > 1) {
                    let i = NimgArray.length - 1
                    arr[imgIndex] = cropperInstance.getCroppedCanvas();
                    arr[imgIndex].toBlob((blob) => {
                        // new Compressor(blob, {
                        //     quality: 0.8,
                        //     success(result) {
                        //         var reader = new FileReader();
                        //         reader.onloadend = function() {
                        //             var base64data = reader.result;      
                        //             arr[imgIndex]=base64data
                        //             // setState({imgIndex:i,imgArray:arr,rotate:0,zoom:1})
                        //             setImgIndex(i)
                        //             setImgArray(arr)
                        //             setRotate(0)
                        //             setZoom(1)
                        //         }
                        //         reader.readAsDataURL(result); 
                        //     }
                        // }
                        // )
                        var options = {
                            maxSizeMB: 1,
                            //maxWidthOrHeight: 1920,
                            useWebWorker: true,
                            fileType: "image/png"
                        }
                        //   imageCompression(blob, options).then(result=>{
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            var base64data = reader.result;
                            arr[imgIndex] = base64data
                            setRotate(0)
                            setZoom(0)
                            setImgArray(arr)
                            setImgIndex(i)
                            // setState({imgIndex:i,imgArray:arr,rotate:0,zoom:0})
                        }
                        reader.readAsDataURL(blob);
                        //   })
                    })
                }

                setLoader(false)
                if (acceptedFiles[0].name.toLowerCase().includes("jpg") || acceptedFiles[0].name.toLowerCase().includes("png") || acceptedFiles[0].name.toLowerCase().includes("jpeg") || acceptedFiles[0].name.toLowerCase().includes("pdf")) {
                    if (acceptedFiles[0].size / (1024 * 1024) > 5) {
                        setResponseStatus({ "message": localeText?.uploadFilesLarger5MBnotAllowed, "type": "error" })
                        setSnackBarOpen(true)
                    }
                    // else {
                    //     NimgArray.push(readBytes.currentTarget.result)
                    //     setImgArray(NimgArray)
                    //     setImgIndex(NimgArray.length - 1)
                    // }
                }
                else {
                    setResponseStatus({ "message": localeText?.uploadValidProof, "type": "error" })
                    setSnackBarOpen(true)
                }

            }
        })
        reader.readAsDataURL(acceptedFiles[0])
    }, [rotate, zoom, imageWidth, imageHeight, value, imgArray, imgIndex])

    useEffect(() => {
        if (title?.toLowerCase().indexOf("aadhaar") > -1) {
            if (imgArray && imgArray.length > 0) {
                var canvas = document.createElement("canvas")
                canvas.id = "canvas" + (canvasId++)
                canvas.style.display = "none"
                document.body.appendChild(canvas)
                var img = document.createElement("img")
                img.id = "scream" + (screamId++)
                img.style.display = "none"
                img.src = imgArray[imgIndex]
                document.body.appendChild(img)
                if (Object.keys(aadharImg).indexOf(imgArray[imgIndex]) != -1) {
                    return;
                }
                if (Object.values(aadharImg).indexOf(imgArray[imgIndex]) != -1) {
                    return;
                }
                if (imgArray[imgIndex] && typeof imgArray[imgIndex] == "string")
                    loadcallback(imgArray[imgIndex].split("base64,")[1])
            } else {
                // setState({imgArray:[]})
            }
        }
    }, [imgArray, imgIndex, title])

    var load = (dt) => {
        var payload = {
            "type": "png",
            "encodedData": dt
        }
        setIsLoading(true)
        axios.post(`${process.env.REACT_APP_API_URL}${config.documentMasking}`, payload).then(response => {
            setIsLoading(false)
            if (response.data.success) {
                var res = response.data.success
                evtPhoto(res)
            } else {
                setResponseStatus({ message: response.data.error, type: 'error' })
                setSnackBarOpen(true)
            }
        }).catch(error => {
            setIsLoading(false)
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
        })
    }

    var loadcallback = useEventCallback(load, {}, [imgArray, imgIndex, title]);

    const evtPhoto = useEventCallback(resp => {
        // loaderEvent.sendMessage(false)
        var r = typeof resp == "string" ? JSON.parse(resp) : resp
        if (!r.responses) {
            return;
        }
        var des = r.responses[0].textAnnotations[0].description.split("\n")
        var filtered = des.filter(txt => /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/gm.test(txt))[0]
        if (!filtered)
            return
        var ann1 = r.responses[0].textAnnotations.filter(ann => ann.description == filtered.split(" ")[0])
        var ann2 = r.responses[0].textAnnotations.filter(ann => ann.description == filtered.split(" ")[1])
        var c = document.getElementById("canvas" + (canvasId - 1));
        var ctx = c.getContext("2d");
        // ctx.canvas.width = window.innerWidth;
        // ctx.canvas.height = window.innerHeight;

        var img = document.getElementById("scream" + (screamId - 1));
        var realWidth = img.naturalWidth;
        var realHeight = img.naturalHeight;
        ctx.canvas.width = realWidth
        ctx.canvas.height = realHeight
        ctx.drawImage(img, 0, 0);
        ctx.fillStyle = '#ffffff';
        ann1.forEach(ann => {
            /*  var p = ctx.getImageData(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y, 1, 1).data; 
             var hex = "#" + ("000000" + rgbToHex(p[0], p[1], p[2])).slice(-6); */
            //ctx.fillStyle=hex
            ctx.beginPath();
            ctx.moveTo(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y);
            ctx.lineTo(ann.boundingPoly.vertices[1].x, ann.boundingPoly.vertices[1].y);
            ctx.lineTo(ann.boundingPoly.vertices[2].x, ann.boundingPoly.vertices[2].y);
            ctx.lineTo(ann.boundingPoly.vertices[3].x, ann.boundingPoly.vertices[3].y);
            ctx.closePath();
            ctx.fill();
        })
        ann2.forEach(ann => {
            ctx.beginPath();
            ctx.moveTo(ann.boundingPoly.vertices[0].x, ann.boundingPoly.vertices[0].y);
            ctx.lineTo(ann.boundingPoly.vertices[1].x, ann.boundingPoly.vertices[1].y);
            ctx.lineTo(ann.boundingPoly.vertices[2].x, ann.boundingPoly.vertices[2].y);
            ctx.lineTo(ann.boundingPoly.vertices[3].x, ann.boundingPoly.vertices[3].y);
            ctx.closePath();
            ctx.fill();
        })
        c.toBlob(blob => {
            var fr = new FileReader()
            fr.onloadend = () => {
                var imgNew = [...imgArray]
                imgNew[imgIndex] = fr.result
                setAadharImg({ ...aadharImg, [fr.result]: imgArray[imgIndex] })
                setImgArray(imgNew)
                document.body.removeChild(c)
                c.remove();
                img.remove()
                c.id = "nil"

            }
            fr.readAsDataURL(blob)
        })
    }, {}, [imgArray])


    useEffect(() => {
        if (imageArray && imageArray.length > 0) {
            setImgArray(imageArray)
            setImgIndex(imageArray.length - 1)
        } else {
            setImgArray([image])
            setImgIndex(0)
        }
    }, [image])

    useEffect(() => {
        if (cropperInstance && rotate && imgArray[0])
            cropperInstance.rotateTo(rotate)
    }, [rotate])

    useEffect(() => {
        if (cropperInstance && zoom && imgArray[0])
            cropperInstance.zoom(zoom)
    }, [zoom])

    function handleSnackBarClose(event, reason) {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const { getRootProps, getInputProps } = useDropzone({ onDrop })

    const handleLivePhotoDialog = () => {
        setOpenLivePhotoDialog(!openLivePhotoDialog)
    }

    return (
        <>
            <DialogTitle id="customized-dialog-title" rotate={rotate} zoom={zoom} value={value} title={title}
                setSizeValue={(e) => {
                    setImageWidth(parseInt(e.target.value.split('x')[0]));
                    setImageHeight(parseInt(e.target.value.split('x')[1]));
                    setValue(e.target.value)
                }}
                setRotate={(rotate) => setRotate(rotate)}
                setZoom={(zoom) => setZoom(zoom)}
                onClose={() => handleClose(imgArray)}  {...props}
            />
            <DialogContent style={matches ? {} : { overflow: "hidden", overflowY: "hidden", height: "calc(100vh - 90px)", flex: "none", padding: '8px 50px' }}>
                <Grid container spacing={2} style={{ height: "calc(100vh - 80px)" }}>
                    <Grid item md={10} lg={10} xl={10} style={{ height: "100%", width: "100%" }}>

                        {
                            imgArray.length > 0 &&
                            <Cropper
                                style={{ height: "100%", width: "100%",overflow:"hidden" }}
                                initialAspectRatio={1}
                                preview=".img-preview"
                                src={imgArray[imgIndex] || image}
                                viewMode={1}
                                guides={true}
                                minCropBoxHeight={10}
                                minCropBoxWidth={10}
                                background={false}
                                responsive={true}
                                autoCropArea={1}
                                checkOrientation={false}
                                onInitialized={(instance) => {
                                    setCropperInstance(instance);
                                }}
                            />
                            // <AvatarEditor
                            //     ref={(ref)=>{_setEditorRef.current=ref}}
                            //     style={{
                            //         margin: "auto",
                            //         width: matches?"100%":"858px",
                            //         height: matches?"50%":"100%",
                            //         background: "rgba(200,200,200,.8)",
                            //         display: "flex",
                            //         flexDirection: "column",
                            //         alignItems: "center",
                            //         justifyContent: "center"
                            //     }}
                            //     image={imgArray.length === 0 ? '' : imgArray[imgIndex] || image}
                            //     width={imageWidth}
                            //     height={imageHeight}
                            //     border={50}
                            //     color={[255, 255, 255, 0.6]} // RGBA
                            //     rotate={rotate}
                            //     scale={zoom}
                            // />
                        }
                        {loader && <CircularProgress size={80} style={{ color: '#F54040', position: "absolute", top: "50%", left: "45%" }} />}
                    </Grid>
                    <Grid item md={2} lg={2} xl={2} direction="row">
                        <Grid container spacing={2} css={{ margin: "2px", height: "100%" }}>
                            {count && <div style={{ marginTop: '10px', marginBottom: '10px' }}><span style={{ fontWeight: 600 }}>{`Note: Maximum ${count === 1 ? `${count} image` : `${count} images`} can be uploaded`}</span></div>}
                            <Grid container direction="column" style={{ height: "60vh", overflowX: "hidden" }}>
                                {imgArray.map((img, i) => (
                                    <div style={{ width: '70px', height: '70px', flexDirection: 'column', margin: '12px' }}>
                                        <Grid item md={2}>
                                            <div css={{ position: "relative" }}>
                                                <img onClick={() => {
                                                    var arr = [...imgArray];
                                                    arr[imgIndex] = cropperInstance.getCroppedCanvas();
                                                    arr[imgIndex].toBlob((blob) => {
                                                        /* new Compressor(blob, {
                                                            quality: (blob.size/1000)>1024?0.8:1,
                                                            success(result) {
                                                                var reader = new FileReader();
                                                                
                                                                reader.onloadend = function() {
                                                                    var base64data = reader.result;     
                                                                    arr[imgIndex]=base64data
                                                                    setState({imgIndex:i,imgArray:arr,rotate:0,zoom:1})
                                                                }
                                                                reader.readAsDataURL(result); 
                                                                
                                                            }
                                                        }
                                                        ) */
                                                        var options = {
                                                            maxSizeMB: 1,
                                                            //maxWidthOrHeight: 1920,
                                                            useWebWorker: true,
                                                            fileType: "image/png"
                                                        }
                                                        // imageCompression(blob, options).then(result=>{
                                                        var reader = new FileReader();
                                                        reader.onloadend = function () {
                                                            var base64data = reader.result;
                                                            arr[imgIndex] = base64data
                                                            setRotate(0)
                                                            setZoom(0)
                                                            setImgArray(arr)
                                                            setImgIndex(i)
                                                            // setState({imgIndex:i,imgArray:arr,rotate:0,zoom:0})
                                                        }
                                                        reader.readAsDataURL(blob);
                                                        // })
                                                    })
                                                }

                                                } style={{ border: imgIndex == i ? "2px solid #F54040" : "1px solid #707070", cursor: "pointer" }} src={img} width={"70px"} height={"70px"} />
                                                <div className={classes.deleteImageDiv} css={{ position: "absolute", cursor: "pointer", backgroundColor: "#24b7cc", width: "30px", height: "30px", borderRadius: "15px", bottom: "55px", left: "50px" }}
                                                    onClick={(e) => {
                                                        var arr = [...imgArray];
                                                        arr.splice(i, 1)
                                                        if (arr.length == 0) {
                                                            cropperInstance.reset()
                                                        }
                                                        setImgArray(arr)
                                                        setRotate(0);
                                                        setZoom(0);
                                                        setImgIndex((arr.length - 1) === -1 ? 0 : (arr.length - 1));
                                                    }} >
                                                    <img src={"images/delete_icon.svg"} alt={"DeleteImage"} className={classes.deleteImage} css={{ padding: "4px 0px 0px 8px" }} />
                                                </div>
                                            </div>

                                        </Grid>
                                        <Grid>
                                            {((imgArray.length < props.multiple) || imgArray.length === 0) && <Grid item md={2} lg={4} xl={12} >
                                                {props.isLivePhotoCapture && title === "Photograph & Signature" ?
                                                    <div onClick={handleLivePhotoDialog} style={{ width: '0px', height: '0px', margin: "auto" }}>
                                                        <img style={{ cursor: "pointer", marginTop: "20px" }} src={"images/add_icon.svg"} width={"70px"} height={"70px"} alt="" />
                                                    </div>
                                                    :
                                                    <div {...getRootProps()} style={{ width: '70px', height: '70px', margin: "auto" }}>
                                                        <input {...getInputProps()} accept={".png, .jpg, .jpeg, "} />
                                                        <img style={{ cursor: "pointer", marginTop: "20px" }} src={"images/add_icon.svg"} width={"70px"} height={"70px"} alt="" />
                                                    </div>}
                                            </Grid>}
                                        </Grid>
                                    </div>
                                ))}
                                <LivePhotoUpload imgArray={imgArray} setImgArray={setImgArray} handleLivePhotoCapture={props.handleLivePhotoCapture} handleLivePhotoDialog={handleLivePhotoDialog} openLivePhotoDialog={openLivePhotoDialog} docId={props.docMId} count={count} docName={title} />
                            </Grid>

                            <Grid item xs={12} className={classes.center} style={{ marginBottom: '10px', position: "relative", flexWrap: "nowrap" }}>
                                <div>
                                    {
                                        props.id.docExpDate &&
                                        <Grid item xs={12}>
                                            <StyledTextField
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                label={localeText?.uploadDocExpiryDate} variant="outlined"
                                            />
                                        </Grid>
                                    }
                                    {
                                        props.id.docNumber &&
                                        <Grid item xs={12}>
                                            <StyledTextField css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                label={localeText?.uploadDocNum} variant="outlined"
                                            />
                                        </Grid>
                                    }
                                </div>
                                <Button
                                    md={2} lg={4} xl={12}
                                    onClick={() => {
                                        var arr = [...imgArray];
                                        if (arr[imgIndex] && typeof cropperInstance !== "undefined") {

                                            (cropperInstance.getCroppedCanvas()).toBlob((blob) => {
                                                /*  new Compressor(blob, {
                                                    quality: 0.8,
                                                    success(result) {
                                                        var reader = new FileReader();
                                                        
                                                        reader.onloadend = function() {
                                                            var base64data = reader.result;          
                                                            arr[imgIndex]=base64data
                                                            onSave(arr)
                                                            cropperInstance.reset()
                                                        }
                                                        reader.readAsDataURL(result); 
                                                        
                                                    }
                                                }
                                                ) */
                                                var options = {
                                                    maxSizeMB: 1,
                                                    //maxWidthOrHeight: 1920,
                                                    useWebWorker: true,
                                                    fileType: "image/png"
                                                }
                                                // imageCompression(blob, options).then(result=>{
                                                var reader = new FileReader();
                                                reader.onloadend = function () {
                                                    var base64data = reader.result;
                                                    arr[imgIndex] = base64data
                                                    cropperInstance.reset()
                                                    onSave(arr)
                                                }
                                                reader.readAsDataURL(blob);
                                                // })
                                            })
                                        }
                                        else {
                                            onSave(arr)
                                        }
                                    }}
                                    color="primary" variant="contained" style={{ margin: "15px 0px 10px 0px" }} disabled={imgArray.length === 0}>
                                    {localeText?.uploadSaveBtn}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            {isLoading && <FullscreenLogoLoader />}
            {
                responseStatus && responseStatus.message &&
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    )
}

export default /* withStyles(styles) */(UploadDialog)
